// extracted by mini-css-extract-plugin
export default {"starterScreen":"Qk","starterImage":"Rk","already":"Sk","starterImageMobile":"Tk","controlX":"Uk","starterTextContain":"Vk","starterHeader":"Wk","starterBtn":"Xk","starterSecondaryBtn":"Yk","starterBanner":"Zk","mobileBtnContainer":"al"};
    if(module.hot) {
      // 1711394575562
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  